module.exports = __webpack_public_path__ + "a0c835eed2fe62e083bbe3bfeee03a79.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/img-app@3x.png
// module id = 1839
// module chunks = 1